<template>
    <img @click="navigate" :src="asset(logoPath, 'img')" class="logo" :class="{link}" :style="style">
</template>
<script>
import GlobalMethods from '@/helpers/global-methods'
import GlobalComputed from '@/helpers/global-computed'

export default {
    props: {
        width: {
            default: null
        },
        height: {
            default: 25,
        },
        link: {
            type: Boolean,
            default: true,
        },
        white: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        style(){
            let style = '';
            if (this.width){
                style += 'width: ' + this.width + 'px';
            }
            if (this.height){
                style += 'height: ' + this.height + 'px';
            }
            return style;
        },
        logoPath(){
            let name = this.white ? 'logo-white' : 'logo';
            return name + '.png';
        },
        isAuthed: GlobalComputed.isAuthed
    },
    methods: {
        ...GlobalMethods,
        navigate(){
            if (this.link){
                if (this.isAuthed){
                    if (this.$route.name !== 'home'){
                        this.$router.push({name: 'home'});
                    }
                }else{
                    if (this.$route.name !== 'welcome'){
                        this.$router.push({name: 'welcome'});
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    
    .logo{
        transition: all 0.2s ease;
        &.link{
            cursor: pointer;

            &:active{
                // opacity: 0.5;
                // transform: scale(0.98);
            }
        }

        // &:hover{
        //     opacity: 0.9;
        // }
    }
</style>